import React from 'react';
import { ABOUT_TEXT, ABOUT_IMAGES } from '../data/mock';

const AboutSection = () => (
  <section className="py-20 md:py-24 bg-white relative overflow-hidden">
    <div className="max-w-[1200px] mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      <div className="order-2 lg:order-1">
        <h2 className="heading-display text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-slate-900">About Us</h2>
        <p className="text-slate-600 leading-8 text-[15px] md:text-base">
          {ABOUT_TEXT}
        </p>
      </div>
      <div className="order-1 lg:order-2 relative h-[480px] md:h-[520px]">
        <div className="absolute top-0 right-0 w-[70%] h-[70%] overflow-hidden rounded-sm shadow-xl">
          <img src={ABOUT_IMAGES.primary} alt="About" className="w-full h-full object-cover" />
        </div>
        <div className="absolute bottom-0 left-0 w-[55%] h-[55%] overflow-hidden rounded-sm shadow-2xl border-4 border-white">
          <img src="https://customer-assets.emergentagent.com/job_site-architecture-1/artifacts/fqlc4wvg_2.jpg" alt="About 2" className="w-full h-full object-cover" />
        </div>
        <div className="absolute top-[10%] left-[42%] flex flex-col gap-1">
          <span className="w-1.5 h-10 bg-[#F97559] inline-block" />
          <span className="w-1.5 h-10 bg-[#2BBECF] inline-block ml-2" />
        </div>
      </div>
    </div>
  </section>
);

export default AboutSection;
